/**
 * Contains application specific configuration items, which is exported and passed to components
 */

const AppConfig = {
  routePaths: {
    login: "/login",
    logout: "/logout",
    home: "/home",
    details: "/details",
    glossary: "/glossary",
    whatsNew: "/whatsNew",
    newJoiner: "/newJoiner",
    results: "/results",
    compare: "/compare",
    recentlyViewAll: "/recentlyViewAll",
    requests: "/requests",
    myDataViewAll: "/myDataViewAll",
    dataProduct: "/dataProduct",
    clientdetails: "/clientdetails",
    dashboard: "/dashboard",
    registerDataProduct: "/registerDataProduct",
  },
  actionPanel: {
    "toastTimeOut": 3000,
    "shareToTeamsUrl": "https://teams.microsoft.com/share?href=%APP_URL%"
  },
  AddTile: {
    "toastTimeOut": 3000,
  },
  collateralDetails: {
    fileFormatIcon: [
      {
        type: "excel",
        values: ['xls', 'xlsx', 'csv']
      },
      {
        type: "word",
        values: ['doc', 'docx']
      },
      {
        type: "ppt",
        values: ['ppt', 'pptx']
      },
      {
        type: "pdf",
        values: ['pdf']
      }
    ]
  },
  myDataViewAll: {
    sortList: ["Recently Added", "Title"],
    defaultSortOrder: {
      recentlyAdded: {
        sortList: [{ property: "EYKDViewCount", direction: 1 }],
        value: "Recently Added"
      },
      title: {
        sortList: [],
        value: "Title"
      }
    }
  },
  resultPage: {
    sortList: ["Relevance", "Popularity", "Title"],
    defaultSortOrder: {
      popularity: {
        sortList: [{ property: "EYKDViewCount", direction: 1 }],
        value: "Popularity"
      },
      relevance: {
        sortList: [],
        value: "Relevance"
      },

      /* date: {
        sortList: [{ property: "EYKDLastUpdatedDate", direction: 1 }],
        value: "Date"
      }, */
      title: {
        sortList: [{ property: "EYKDTitle", direction: 0 }],
        value: "Title"
      },
      topic: {
        sortList: [{ property: "EYKDSortOrder", direction: 0 }],
        value: "Title"
      }
    },
    resultTitle: {
      essentials: "Essentials {count} result(s)",
      mostpopular: "Most Popular {count} result(s)",
      searchTitle: "{count} Result(s)"
    },
    dataProviderHoverImageURL: "/assets/images/Data%20Provider/Data-Provider-Logo_Yellow_Hover.jpg"
  },
  metaData:
  {
    title: "",
    sectionType: "data_table",
    subSections: {
      left: [
        {
          title: "Topic",
          displayProperty: "EYKDTopics"
        },
        {
          title: "Category",
          displayProperty: "owstaxIdEYKDCategory",
          id: "dataCategory",
          dataType: "taxonomy"
        },
        {
          title: "Sector",
          displayProperty: "owstaxIdEYKDSector",
          id: "sector",
          dataType: "taxonomy"
        },
        {
          title: "Service Line",
          displayProperty: "owstaxIdEYKDServiceLine",
          id: "serviceLine",
          dataType: "taxonomy"
        },
        {
          title: "Language",
          displayProperty: "owstaxIdEYKDLanguage",
          id: "language",
          dataType: "taxonomy"
        },
        {
          title: "Data Provider Type",
          displayProperty: "EYKDProviderType",
          id: "dataProviderType"
        },
        {
          title: "Delivery Method",
          displayProperty: "EYKDDataDelivery",
          id: "dataDelivery"
        },
      ],
      right: [
        {
          title: "Geo Access",
          displayProperty: "owstaxIdEYKDGeoAccess",
          id: "geoScope",
          dataType: "taxonomy"
        },
        {
          title: "Geo Scope",
          displayProperty: "owstaxIdEYKDGeoScope",
          id: "geoScope",
          dataType: "taxonomy"
        },
      ]
    }
  },
  clientMetaData:
  {
    title: "",
    sectionType: "data_table",
    subSections: {
      left: [
        {
          title: "Topic",
          displayProperty: "EXP_Topic"
        },
        {
          title: "Category",
          displayProperty: "EXP_Category",
          id: "dataCategory",
          dataType: "taxonomy"
        },
        {
          title: "Sector",
          displayProperty: "owstaxIdEYKDSector",
          id: "sector",
          dataType: "taxonomy"
        },
        {
          title: "Service Line",
          displayProperty: "owstaxIdEYKDServiceLine",
          id: "serviceLine",
          dataType: "taxonomy"
        },
        {
          title: "Language",
          displayProperty: "owstaxIdEYKDLanguage",
          id: "language",
          dataType: "taxonomy"
        },
        {
          title: "Data Provider Type",
          displayProperty: "EYKDProviderType",
          id: "dataProviderType"
        },
        {
          title: "Delivery Method",
          displayProperty: "EYKDDataDelivery",
          id: "dataDelivery"
        },
      ],
      right: [
        {
          title: "Geo Access",
          displayProperty: "EY_Region_Access",
          id: "geoScope",
          dataType: "taxonomy"
        },
        {
          title: "Geo Scope",
          displayProperty: "EYGeoScope",
          id: "geoScope",
          dataType: "taxonomy"
        },
      ]
    }
  },
  relatedAssetsQuery: {
    sortList: [
      {
        Property: 'EYKDAssetType', Direction: 0
      }
    ]
  },
  manageCart: {
    maxItemsAddToCart: 100
  },
  newDataProductPage: {
    sortList: ["Yes", "No"],
    defaultSortOrder: {
      Yes: {
        sortList: [],
        value: "Yes"
      },
      No: {
        sortList: [],
        value: "No"
      },
    },
  },
  dompurifyConfig: {
   ADD_ATTR: ['target']
  },

};

export default AppConfig;